import Trainee from "./Trainee";

export default Trainee;
